import * as React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';

import { actions as homeActions } from '../../actions/home.actions';
import { AnyAaaaRecord } from 'dns';
import Container from 'src/core/ui/container';
import Grid, { Col } from './grid';
import {IApplicationState} from "../../typings";

export interface PrivateRouteProps {
    isAuthenticated?: boolean;
    path?: string;
    component?: any;
    exact?: boolean;
    extraValidation?: (values: any) => Promise<boolean>;
}

export interface PrivateRouteState {
}

export class PrivateRoute extends React.Component<PrivateRouteProps & typeof homeActions, PrivateRouteState> {
  
    constructor(props: any) {
        super(props);

        this.state = {
        }
    }

  public componentDidMount(){
     this.props.toggleLogin(!this.props.isAuthenticated, 0);
     
  }

  public componentWillReceiveProps(nextProps: PrivateRouteProps){
      if(nextProps.isAuthenticated){
          this.props.toggleLogin(false, 0);
      }
  }

  public render() {

    if(!this.props.isAuthenticated)
        return (<Container>
            <Grid centered>
                <Col size={80}>
                    <h1 className='unauth'>Unauthorized access</h1>
                </Col>
            </Grid>
        </Container>);

    return (
        <Route exact={this.props.exact}  path={this.props.path} component={this.props.component}>
            {this.props.children}
        </Route>
    );
  }
}

function mapStateToProps(state: IApplicationState, ownProps: any){
    return {
        ...ownProps,
        isAuthenticated: state.identity.isAuthenticated
    }
}

export default connect(mapStateToProps, {...homeActions})(PrivateRoute);


// WEBPACK FOOTER //
// ./src/core/ui/private-route.tsx